import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import {
  DeletePhosphateLegalWorkingCoefficientResponse,
  GetPhosphateLegalWorkingCoefficients,
  PhosphateLegalWorkingCoefficient,
  PhosphateLegalWorkingCoefficientsFilter,
  UpsertPhosphateLegalWorkingCoefficientResponse,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class PhosphateLegalWorkingCoefficientService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/field-report/secure/phosphatelegalworkingcoefficient';

  getPhosphateLegalWorkingCoefficients(
    pageNumber: number,
    pageSize: number,
    filter: PhosphateLegalWorkingCoefficientsFilter,
  ): Observable<GetPhosphateLegalWorkingCoefficients> {
    let url = `${this.baseUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (filter.year) {
      url += `&calendarYear=${filter.year}`;
    }
    return this.http.get<GetPhosphateLegalWorkingCoefficients>(url);
  }

  upsertPhosphateLegalWorkingCoefficient(phosphateLegalWorkingCoefficient: PhosphateLegalWorkingCoefficient) {
    return this.http.post<UpsertPhosphateLegalWorkingCoefficientResponse>(this.baseUrl, phosphateLegalWorkingCoefficient, {});
  }

  deletePhosphateLegalWorkingCoefficient(phosphateLegalWorkingCoefficientsId: number) {
    return this.http.delete<DeletePhosphateLegalWorkingCoefficientResponse>(this.baseUrl + '/' + phosphateLegalWorkingCoefficientsId);
  }
}
